import {API} from "aws-amplify";
import {GRAPHQL_AUTH_MODE, GraphQLQuery} from "@aws-amplify/api";
import {ListManualsByImagesQuery, ListManualsByImagesQueryVariables} from "../../API";
import * as queries from "../../graphql/queries";

export const getManualsByImages = async (
    fileNames: String[]
): Promise<any> => {
    try {
        const result = await API.graphql<GraphQLQuery<ListManualsByImagesQuery>>({
            query: queries.listManualsByImages,
            variables: {
                fileNames: fileNames,
            } as ListManualsByImagesQueryVariables,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        });

        if (result.data) {
            const data = result.data.listManualsByImages;
            if (data) {
                const parsedData = JSON.parse(data);
                return JSON.parse(parsedData["manuals"]);
            }
        }
    } catch (error) {
        throw error;
    }
};
